import { CanActivate, CanLoad, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Injectable } from '@angular/core';

@Injectable({providedIn:'root'})
export class AuthGuard implements CanLoad, CanActivate {
  constructor(private auth: AuthService, private router: Router) { }

  canLoad(): boolean {
    console.log('auth canload: '+this.auth.getToken());
    if (!this.auth.getToken()) {
      // Salva l'URL corrente per il redirect dopo il login
      this.auth.setRedirectUrl(window.location.pathname);
      this.router.navigate(['/login'], { replaceUrl: true });
      return false;
    }
    return true;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    console.log('auth canActivate: '+this.auth.getToken());
    if (!this.auth.getToken()) {
      // Salva l'URL richiesto per il redirect dopo il login
      this.auth.setRedirectUrl(state.url);
      this.router.navigate(['/login'], { replaceUrl: true });
      return false;
    }
    return true;
  }
};
